export default {
  isValidDefinition(definition) {
    if (_.isEmpty(definition)) {
      return false;
    } else if ((!!definition.$and && _.isEmpty(definition.$and)) && (!!definition.$or && _.isEmpty(definition.$or))) {
      return false;
    } else {
      let extractedRules = this.extractRules(definition);
      return this.areRulesValid(extractedRules);
    }
  },
  extractRules(definition) {
    let rules = [];
    if(definition.$and) {
      rules = rules.concat(definition.$and);
    }
    if(definition.$or) {
      rules = rules.concat(definition.$or);
    }
    return rules;
  },
  areRulesValid(rules) {
    let isValid = true;
    _.forEach(rules, (rule) => {
      _.forEach(rule, (value, key) => {
        if(key === 'undefined' || !value || !this.isRuleValueValid(value)) {
          isValid = false;
        }
      });
    });

    return isValid;
  },
  isRuleValueValid(ruleValue) {
    let isValid = true;
    _.forEach(ruleValue, (value, key) => {
      if(key === 'undefined'
        || key === 'null'
        || value === null
        || value === undefined
        || value instanceof Array && value.length === 0) {
        isValid = false;
      }
    });
    return isValid;
  }

}



/** WEBPACK FOOTER **
 ** ./src/components/segments/segmentsDefinitionValidation.js
 **/